import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Text buttons — never with store logos. Renders <a> for `href`, <Link> for `to`.
 * variant: 'kmo' | 'grad' | 'bmb' | 'ghost'; size: 'sm'. `sub` adds a small second line.
 */
const MkBtn = ({ variant = 'kmo', size, href, to, sub, className, children, onClick, ...rest }) => {
  const classes = ['mk-btn', `mk-btn--${variant}`, size && `mk-btn--${size}`, sub && 'mk-btn--stacked', className]
    .filter(Boolean)
    .join(' ');
  const inner = sub ? (
    <span className="mk-btn__text">
      <span className="mk-btn__label">{children}</span>
      <span className="mk-btn__sub">{sub}</span>
    </span>
  ) : (
    <span className="mk-btn__label">{children}</span>
  );
  if (to) {
    return (
      <Link {...rest} to={to} className={classes} onClick={onClick}>
        {inner}
      </Link>
    );
  }
  return (
    <a {...rest} href={href} className={classes} onClick={onClick}>
      {inner}
    </a>
  );
};

export default MkBtn;
